// extracted by mini-css-extract-plugin
export default {"wrapper":"PhyEuOTxjfbjn7Mukxk9","whiteBackground":"SGYb6WIZyeMQ8UXeoi24","button":"Ybxs1YEJmFOOYccHfE_F"};